<template>
  <div class="content">
    <el-dialog top="5vh"
               title="模板选择"
               :visible.sync="dialogFormVisible"
               @close="handleToClose"
               :close-on-click-modal="false"
               width="55%"
               append-to-body
               @open="openDialog">
      <div class="search-wrap">
        <div class="searchTitle"></div>
        <el-form class="search-wrap"
                 ref="searchForm"
                 :inline="true"
                 :model="query"
                 size="small"
                 label-position="left">
          <el-form-item>
            <el-form-item label="模板名称">
              <el-input v-model="query.name_keyword"
                        placeholder="请输入模板名称"
                        @input="templateList()"
                        clearable></el-input>
            </el-form-item>
          </el-form-item>
          <el-form-item label="创建人">
            <el-select v-model="query.statuses"
                       placeholder="请选择"
                       @change="templateList()"
                       clearable>
              <el-option v-for="item in $store.state.adminList"
                         :key="item.id"
                         :label="item.nickname"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

        </el-form>
      </div>
      <el-table :data="result"
                row-key="id"
                :header-cell-style="{
          backgroundColor: '#F2F6FC',
          color: '#909399',
          fontSize: '14px',
        }"
                :cell-style="{ fontSize: '13px' }"
                @selection-change="handleSelectionChange"
                @select="selectRow"
                @selectAll="selectAll"
                ref="tableInfo"
                :header-row-class-name="hideSelectAll"
                border>
        <el-table-column type="selection"
                         :reserve-selection="true"
                         width="50"
                         align="center"> </el-table-column>
        <el-table-column label="ID"
                         align="center"
                         width="120">
          <template slot-scope="scope">
            {{
              scope.row.id
            }}
          </template>
        </el-table-column>
        <el-table-column label="名称"
                         align="center"
                         width="250">
          <template slot-scope="scope">
            {{
              scope.row.name
            }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="价格及配送区域"
                         align="center"
                         width="120">
          <template slot-scope="scope">
            {{
              scope.row.manage_creator ? scope.row.manage_creator.nickname : ""
            }}
          </template>
        </el-table-column> -->
        <el-table-column label="创建人"
                         align="center"
                         width="200">
          <template slot-scope="scope">
            {{ formateCreator(scope.row.creator) }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间"
                         align="center"
                         width="200">
          <template slot-scope="scope">
            <span>{{  $moment(scope.row.create_time).format('YYYY-MM-DD HH:mm')  }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
        <div class="confirm"
             @click="confirm()">确定</div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { expressTemplateList } from '@/api/index.js'
export default {
  components: {},
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    dataForm: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      row: {},
      selected: [],
      chooseList: [],
      dialogFormVisible: this.isVisible,
      result: [],
      query: {
        name: '',
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
      },
      pageTotal: 0,
    }
  },

  watch: {
    isVisible(val) {
      this.dialogFormVisible = val
      if (val) {
        // console.log("tyoe",this.teacher_id)
        if (this.flag) {
          this.query.force_inner_order_types = '1,2'
        }
        // this.fetchList(true)
        // console.log(this.teacher_allocation_order_id);
      }
    },
  },
  created() {
    this.$store.dispatch('getReadCategorys')
    this.$store.dispatch('getAdminList')
  },
  mounted() {
    this.templateList()
  },
  methods: {
    openDialog() {
      this.$nextTick(() => {
        this.result.map((item) => {
          if (item.name == this.dataForm.templateName) {
            this.row = item
          }
        })
        this.chooseList[0] = this.row
        this.$refs.tableInfo.clearSelection()
        this.$refs.tableInfo.toggleRowSelection(this.row)
        this.$emit('choseList', this.chooseList)
      })
    },
    confirm() {
      this.$emit('choseList', this.chooseList)
      this.$emit('templateList', this.result)
      this.dialogFormVisible = false
    },
    handleSelectionChange(data) {
      this.chooseList = data
      console.log('this.selected', this.chooseList)
    },
    selectRow(selection) {
      console.log('selection', selection)
      if (selection.length > 1) {
        let del_row = selection.shift()
        this.$refs.tableInfo.toggleRowSelection(del_row, false)
      }
    },
    selectAll(selection) {
      if (selection.length > 1) {
        selection.length = 1
      }
    },
    hideSelectAll({ cloumnIndex }) {
      if (cloumnIndex == 0) {
        return 'hideSelectAll'
      }
    },
    // 获取运费模板列表
    templateList() {
      expressTemplateList(this.query).then((res) => {
        this.result = res.list
        console.log('this.result', this.result)
        this.$emit('result', this.result)
        this.pageTotal = res.count
        if (this.dataForm.templateName == '') {
          this.chooseList = this.result[0]
        }
      })
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.templateList()
    },
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.templateList()
    },
    formateCreator(val) {
      if (this.$store.state.adminList.length) {
        if (val) {
          if (
            this.$store.state.adminList.findIndex((v) => {
              return v.id == val
            }) > -1
          ) {
            return this.$store.state.adminList.find((v) => {
              return v.id == val
            }).nickname
          } else {
            return '无'
          }
        } else {
          return '无'
        }
      }
    },
    handleToClose() {
      this.$emit('close')
      this.$emit('submit')
    },
  },
}
</script>
  <style>
.hideSelectAll .cell {
  visibility: hidden;
}
</style>
<style lang="less" scoped>
::v-deep .el-dialog__header {
  // border: 1px solid red !important;
  background: #ebeef5;
  border-radius: 4px 4px 0px 0px;
}

::v-deep .el-table thead {
  // 第一种
  .el-checkbox__input {
    display: none !important;
  }
}
.footer {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  .confirm {
    color: #ffff;
    cursor: pointer;
    font-size: 14px;
    text-align: center;
    line-height: 32px;
    background: #409eff;
    border-radius: 4px 4px 4px 4px;
    width: 56px;
    height: 32px;
  }
}

.search-wrap {
  position: relative;
  // margin-bottom: 24px;
  .searchTitle {
    position: absolute;
    top: 0;
    width: 100%;
    height: 57px;
    // border: 1px solid red;
  }
}

.footer-wrap {
  display: flex;
  margin-top: 24px;
  justify-content: space-between;
  align-items: center;
}

.img-list {
  margin-top: 12px;
  display: flex;
  align-items: center;

  img {
    width: 140px;
    height: 140px;
    margin-right: 12px;
    border-radius: 4px;
  }
}
</style>